// extracted by mini-css-extract-plugin
module.exports = {"mask":"_5D1FrObq","mask__card":"_5D3xYXJ0","mask__title":"_5DD0J3b9","mask__message":"_5D3a73XJ","mask__button":"_5D3-uB0l","mask__button-decline":"_5D2tg-Lg"};